var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.href ? 'a' : 'div',{tag:"component",staticClass:"common-image",class:{ _absolute: _vm.isAbsolute },style:(_vm.borderRadius ? { borderRadius: _vm.borderRadius } : null),attrs:{"href":_vm.href,"target":_vm.href ? _vm.target : null}},[_c('common-lazy-background',{attrs:{"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }